import React, {useState, forwardRef, useImperativeHandle} from "react";
import Button from "react-bootstrap/Button";
import axios from "axios";
import apiUrl from "../../shared/config";
import SubmitButtonWarning from "../UI/SubmitButtonWarning/SubmitButtonWarning";

const SubmitCommentButton = forwardRef(({token, update, userId, commentId, pattern_id, getComment, resetComment, buttonStyle, buttonText, onSubmit = () => {}, disable = false, hideButton = false}, ref ) => {
    const [showFailMessage, setShowFailMessage] = useState(false);
    const [failMessage, setFailMessage] = useState("");

    function handleSubmit() {
        let data = {
            pattern_id: pattern_id, comment: getComment
        };

        if (commentId) {
            data["comment_id"] = commentId;
            data["user_id"] = parseInt(userId);
        }

        if (String(data.comment).trim().length > 0) {
            axios.post(apiUrl + "Pattern/setComment?token=" + token, data)
                .then(response => {
                    console.log('Post successful:', response.data);
                    if (!response.data.message) {
                        setShowFailMessage(false);
                        resetComment();
                        update();
                    } else {
                        setShowFailMessage(true);
                        setFailMessage(response.data.message);
                    }
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });
        } else {
            setShowFailMessage(true)
            setFailMessage('EMPTY_FIELD')
        }
        onSubmit();
    }

    useImperativeHandle(ref, () => ({
        submit: () => handleSubmit()
    }))

    return (
        <SubmitButtonWarning
            token={token} userId={userId}
            handleSubmit={handleSubmit}
            failMessage={failMessage}
            setShowFailMessage={setShowFailMessage}
            showFailMessage={showFailMessage}
            postType={{
                lowercase: "comments",
                capital: "Comment",
                capitalLowercase: "Comments",
            }}
            submitButton={
                !hideButton ?
                <Button className={'preset-modal-button-button'} key={buttonStyle} onClick={() => {
                    if (!disable) {
                        handleSubmit()
                    } else {
                        setShowFailMessage(true)
                        setFailMessage("ALREADY_SUBMITTED")
                    }
                }} style={buttonStyle}>
                    {buttonText}
                </Button>
                    : <></>
            }
        />)
})

export default SubmitCommentButton;